import { storage } from '@itau-loans-www/utils'

import auth from './auth'

export const defaultLeadsApiCall = async ({ endpoint, method, body = {} }) => {
  const { leadId } = storage.session.getItem('token')

  const response = await auth({}).then((_http) =>
    _http[method](`v2/itau-loans-api/leads/${leadId}/${endpoint}`, body)
  )

  return response
}
